import React, { useState, useCallback, memo } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const CreateAgent = memo(() => {
  const { currentUser } = useSelector((state) => state.user);
  const [formData, setFormData] = useState({});
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = useCallback((e) => {
    const { id, value } = e.target;
    setFormData(prev => ({ ...prev, [id]: value }));
  }, []);

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      setError(null);

      const response = await axios.post(
        `/api/user/createbranch/${currentUser._id}`,
        formData
      );

      if (response.data.success) {
        alert("Agent created successfully!");
        navigate("/admin");
      } else {
        setError(response.data.message || "Failed to create agent");
      }
    } catch (error) {
      console.error("Create agent error:", error);
      setError(error.response?.data?.message || "Error creating agent");
    } finally {
      setLoading(false);
    }
  }, [formData, currentUser._id, navigate]);

  return (
    <div className="tw-flex tw-justify-center tw-items-center tw-bg-slate-100 tw-min-h-screen">
      <div className="tw-bg-white tw-p-8 tw-rounded-lg tw-shadow-md tw-w-full tw-max-w-md">
        <h1 className="tw-text-2xl tw-font-bold tw-text-center tw-mb-6">Create New Agent</h1>
        
        <form onSubmit={handleSubmit} className="tw-flex tw-flex-col tw-gap-4">
          {/* Form Fields */}
          {[
            { id: "name", type: "text", placeholder: "Full Name", required: true },
            { id: "username", type: "text", placeholder: "Username", required: true },
            { id: "phone", type: "number", placeholder: "Phone number", required: true },
            { id: "password", type: "password", placeholder: "Password", required: true },
            { id: "cut", type: "text", placeholder: "Cut", required: true }
          ].map((field) => (
            <input
              key={field.id}
              type={field.type}
              id={field.id}
              placeholder={field.placeholder}
              required={field.required}
              onChange={handleChange}
              className="tw-w-full tw-h-10 tw-rounded-lg tw-border tw-border-slate-300 tw-p-3 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-blue-500"
            />
          ))}

          {/* Role Selection */}
          <div className="tw-flex tw-gap-5 tw-w-full">
            <label htmlFor="role" className="tw-text-lg tw-font-bold tw-min-w-[80px]">
              Role:
            </label>
            <select
              id="role"
              onChange={handleChange}
              className="tw-flex-grow tw-rounded-lg tw-border tw-border-slate-300 tw-p-2.5 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-blue-500"
              defaultValue="employee"
            >
              <option value="employee">Employee</option>
              <option value="admin">Admin</option>
              <option value="agent">Agent</option>
              {currentUser.role === "superadmin" && (
                <option value="superadmin">Super Admin</option>
              )}
            </select>
          </div>

          {/* Submit Button */}
          <button
            disabled={loading}
            type="submit"
            className="tw-w-full tw-font-semibold tw-p-3 tw-rounded-lg tw-text-white tw-bg-blue-600 hover:tw-bg-blue-700 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 disabled:tw-opacity-50"
          >
            {loading ? "Creating Agent..." : "Create Agent"}
          </button>
        </form>

        {error && <p className="tw-text-red-500 tw-mt-4 tw-text-center">{error}</p>}
      </div>
    </div>
  );
});

export default CreateAgent;